module.exports = __webpack_public_path__ + "img/dab_ostoja_spokoju.b96c78c7.jpg";